import React from 'react'
import { CheckboxStyle } from './style'
import { Error } from '../Input/style'

const Checkbox = ({ children, className, register, error, ...props }) => {
	return (
		<CheckboxStyle className={className}>
			<input type='checkbox' ref={register} {...props} />
			<span>{children}</span>
			{error && <Error>{error.message}</Error>}
		</CheckboxStyle>
	)
}
export default Checkbox
